export const APP_NAME = 'Arthaus Admin'

export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: [10, 20, 30, 50, 100],
} as const

export const UPLOAD = {
  MAX_FILE_SIZE: 200 * 1000 * 1000, // 200 MB, as the API counts it (lib/chunked-upload.js)
  ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/jpg', 'image/png'],
  ALLOWED_IMAGE_EXTENSIONS: ['.jpg', '.jpeg', '.png'],
} as const

export const TAGS = {
  MAX_PER_ARTWORK: 5,
} as const

